module.exports = __webpack_public_path__ + "img/menu_audience.ad717704.png";